import React from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import styles from './verificationCard.module.css';

const VerificationCard = ({ icon: Icon, title, subTitle, attemptText }) => (
    <Box className={styles.card}>
        <Box className={styles.iconBox}>
            <Icon className={styles.icon} />
        </Box>
        <Typography className={styles.title}>{title}</Typography>
        {subTitle && <Typography className={styles.subTitle}>{subTitle}</Typography>}
        <Typography className={styles.attempts}>{attemptText}</Typography>
    </Box>
);

VerificationCard.propTypes = {
    icon: PropTypes.elementType.isRequired,
    title: PropTypes.string.isRequired,
    subTitle: PropTypes.string,
    attemptText: PropTypes.string,
};

export default VerificationCard;
